const translated ={
  x: {
    cz: "testovaci preeklad",
    en: "testovaci preeklad EN",
  },
  restaurace: {
    menu: {
      title_empty_sections: {
        cz: "Pridejte nejdriv alespon jednu sekci",
        en: "Pridejte nejdriv alespon jednu sekci EN",
      },
      title_empty_restaurant: {
        cz: "musi byt vybrana restaurace",
        en: "musi byt vybrana restaurace EN",
      },
      section: {
        title_presun: {
          cz: "Presunout sekci",
          en: "Presunout sekci EN",
        },
        title_empty_meals: {
          cz: "V sekci nejsou zadne jidla",
          en: "V sekci nejsou zadne jidla EN",
        },
        title_create_new_section: {
          cz: "Vytvořit novou sekci jídelního lístku",
          en: "Vytvorit novou sekci EN",
        },
        title_empty_section: {
          cz: "V této sekci není žádné jídlo!",
          en: "V této sekci není žádné jídlo! EN",
        },
        title_hidden_meals: {
          cz: "Sekce je v editaci skryta",
          en: "Sekce je v editaci skryta EN",
        },
        title_meals_count: {
          cz: "ks",
          en: "pc",
        },
      },
      jidlo: {
        title_not_display: {
          cz: "Toto jidlo se nebude zobrazovat",
          en: "Toto jidlo se nebude zobrazovat EN",
        },
        hint_not_display: {
          cz: "Zobrazeni muzete zmenit v editaci jidla",
          en: "Zobrazeni muzete zmenit v editaci jidla EN",
        },
        title_no_price: {
          cz: "Jidko bez ceny se nebude zobrazovat",
          en: "Jidlo neni zobrazene, muzete ho editovat EN",
        },
        title_nezobrazeni: {
          cz: "Jidlo neni zobrazene, muzete ho editovat",
          en: "Jidlo neni zobrazene, muzete ho editovat EN",
        },
        title_presun: {
          cz: "Presunout jidlo",
          en: "Presunout jidlo EN",
        },
        cena: {
          placeholder: {
            cz: "Cena jidla",
            en: "Meal price EN",
          },
        },
        varianta: {
          cena: {
            title_no_price: {
              cz: "VAR Jidlo bez ceny se nebude zobrazovat",
              en: "Jidlo neni zobrazene, muzete ho editovat EN",
            },
            placeholder: {
              cz: "Cena varianty jidla",
              en: "Cena varianty jidla",
            },
          }
        }
      },

    }
  }
}
//restaurace.menu.title_create_new_section
export default translated;